import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="font-display text-4xl italic mb-8 text-light-text dark:text-pure-white">
        Privacy Policy
      </h1>

      <div className="prose dark:prose-invert font-body text-light-text dark:text-silver space-y-6">
        <p className="text-light-text-secondary dark:text-silver/80">
          Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
        </p>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            1. Introduction
          </h2>
          <p>
            Calendiary ("we," "our," or "us") is committed to protecting your privacy. This Privacy
            Policy explains how we collect, use, disclose, and safeguard your information when you
            use our medical appointment booking platform.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            2. Information We Collect
          </h2>
          <p>We collect information that you provide directly to us, including:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Account information (name, email address, password)</li>
            <li>Profile information (phone number, date of birth)</li>
            <li>Appointment details and medical preferences</li>
            <li>Payment information (processed securely through Stripe)</li>
            <li>Communications with healthcare providers</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            3. How We Use Your Information
          </h2>
          <p>We use the information we collect to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Provide and maintain our services</li>
            <li>Process appointments and payments</li>
            <li>Send appointment reminders and notifications</li>
            <li>Improve our platform and user experience</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            4. Information Sharing
          </h2>
          <p>We may share your information with:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Healthcare providers you choose to book appointments with</li>
            <li>Service providers who assist in our operations</li>
            <li>Legal authorities when required by law</li>
          </ul>
          <p>
            We do not sell your personal information to third parties.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            5. Data Security
          </h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal
            information against unauthorized access, alteration, disclosure, or destruction. However,
            no method of transmission over the Internet is 100% secure.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            6. Your Rights
          </h2>
          <p>You have the right to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Access your personal information</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Opt-out of marketing communications</li>
            <li>Export your data in a portable format</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            7. Cookies and Tracking
          </h2>
          <p>
            We use cookies and similar tracking technologies to improve your experience on our
            platform. You can control cookie settings through your browser preferences.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            8. Children's Privacy
          </h2>
          <p>
            Our service is not intended for children under 13 years of age. We do not knowingly
            collect personal information from children under 13.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            9. Changes to This Policy
          </h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes
            by posting the new Privacy Policy on this page and updating the "Last updated" date.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            10. Contact Us
          </h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at{' '}
            <a href="mailto:privacy@calendiary.com" className="text-light-text dark:text-pure-white underline hover:opacity-80">
              privacy@calendiary.com
            </a>
          </p>
        </section>
      </div>

      <div className="mt-12 pt-8 border-t border-light-text/10 dark:border-silver/10">
        <Link
          to="/"
          className="inline-flex items-center gap-2 font-body text-sm text-light-text-secondary dark:text-silver/80 hover:text-light-text dark:hover:text-pure-white transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
          </svg>
          Back to Homepage
        </Link>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
